export default {
    customer : "",
    make :"",
    equipement: "",
    typeofShip : "",
    vessel:"",
    model : "",
    fleet : ""

 }